import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M3 6.1875C3 5.73995 3.18964 5.31072 3.52721 4.99426C3.86477 4.67779 4.32261 4.5 4.8 4.5H19.2C19.6774 4.5 20.1352 4.67779 20.4728 4.99426C20.8104 5.31072 21 5.73995 21 6.1875V16.3125C21 16.7601 20.8104 17.1893 20.4728 17.5057C20.1352 17.8222 19.6774 18 19.2 18H4.8C4.32261 18 3.86477 17.8222 3.52721 17.5057C3.18964 17.1893 3 16.7601 3 16.3125V6.1875ZM6.1671 6.1875L12 10.9724L17.8329 6.1875H6.168H6.1671ZM19.2 7.30884L12.5931 12.7291C12.429 12.8639 12.2182 12.9382 12 12.9382C11.7818 12.9382 11.571 12.8639 11.4069 12.7291L4.8 7.30884V16.3125H19.2V7.30884Z' />
        </SvgIcon>
    );
});
